/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type ListEffectivePricesRequest = {
  /**
   * Optional external end-user identifier forwarded by the API gateway.
   */
  xOnBehalfOf?: string | undefined;
};

/** @internal */
export const ListEffectivePricesRequest$inboundSchema: z.ZodType<
  ListEffectivePricesRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  "X-On-Behalf-Of": z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    "X-On-Behalf-Of": "xOnBehalfOf",
  });
});
/** @internal */
export type ListEffectivePricesRequest$Outbound = {
  "X-On-Behalf-Of"?: string | undefined;
};

/** @internal */
export const ListEffectivePricesRequest$outboundSchema: z.ZodType<
  ListEffectivePricesRequest$Outbound,
  z.ZodTypeDef,
  ListEffectivePricesRequest
> = z.object({
  xOnBehalfOf: z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    xOnBehalfOf: "X-On-Behalf-Of",
  });
});

export function listEffectivePricesRequestToJSON(
  listEffectivePricesRequest: ListEffectivePricesRequest,
): string {
  return JSON.stringify(
    ListEffectivePricesRequest$outboundSchema.parse(listEffectivePricesRequest),
  );
}
export function listEffectivePricesRequestFromJSON(
  jsonString: string,
): SafeParseResult<ListEffectivePricesRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListEffectivePricesRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListEffectivePricesRequest' from JSON`,
  );
}
